import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const PagePermissionContext = createContext(null);

export const PagePermissionProvider = ({ permissions, children }) => (
  <PagePermissionContext.Provider value={permissions}>
    {children}
  </PagePermissionContext.Provider>
);

export const usePagePermissions = () => {
  const context = useContext(PagePermissionContext);
  if (!context) {
    throw new Error(
      'usePagePermissions must be used within a PagePermissionProvider'
    );
  }
  return context;
};

PagePermissionProvider.propTypes = {
  permissions: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
};
